import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {runSchemaURL} from 'results/assay-schemas/AssaySchemaDAO';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';

export default function RunSchemaChip(props: SharedSmartChipProps<SmartChipType.RUN_SCHEMA>): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: runSchema,
    handleClickLink,
    isInaccessible,
    itemUrl: runSchemaUrl,
  } = useSmartChipQuery<SmartChipType.RUN_SCHEMA>({
    id,
    onClick,
    getUrlFn: (runSchema) => runSchemaURL(runSchema.id),
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={ModelTypeConstants.ASSAY_SCHEMA}
      isInaccessible={isInaccessible}
      item={runSchema}
      onClick={handleClickLink}
      url={runSchemaUrl}
    />
  );
}
